import React from "react";

export function Field({ label, error, hint, children, className = "" }) {
  return (
    <label className={`phx-field ${error ? "phx-field-error" : ""} ${className}`}>
      <span>{label}</span>
      {children}
      {hint ? <small>{hint}</small> : null}
      {error ? <strong role="alert">{error}</strong> : null}
    </label>
  );
}

export function YesNo({ label, name, value, onChange, error }) {
  return (
    <fieldset className={`phx-choice-field ${error ? "phx-field-error" : ""}`}>
      <legend>{label}</legend>
      <div className="phx-inline-options">
        {["yes", "no"].map((option) => (
          <label key={option}>
            <input
              type="radio"
              name={name}
              value={option}
              checked={value === option}
              onChange={(event) => onChange(event.target.value)}
            />
            {option === "yes" ? "Yes" : "No"}
          </label>
        ))}
      </div>
      {error ? <strong role="alert">{error}</strong> : null}
    </fieldset>
  );
}

export function ErrorSummary({ errors }) {
  const messages = [...new Set(Object.values(errors || {}))];
  if (!messages.length) return null;
  return (
    <div className="phx-error-summary" role="alert" tabIndex="-1">
      <strong>Please check this section</strong>
      <ul>{messages.map((message) => <li key={message}>{message}</li>)}</ul>
    </div>
  );
}

